export const API_URL = process.env.REACT_APP_API_URL as string;
export const ODDO_URL = process.env.REACT_APP_ODDO_URL as string;
export const LOGROCKET_PROJECT = process.env.REACT_APP_LOGROCKET_PROJECT as string;
export const ALLOWED_DOMAINS = process.env.REACT_APP_ALLOWED_DOMAINS as string;
